// Azure raw PCM: signed little-endian 16-bit samples, mono, 16000 Hz.
// Each instance belongs to one utterance; never reuse it across turns.
export class DirectCallPcmDecoder {
  private pending: number | null = null;
  private closed = false;

  decode(chunk: Uint8Array): Float32Array {
    if (this.closed) throw new Error('Audio stream has ended');
    const samples = new Float32Array(
      Math.floor((chunk.byteLength + (this.pending === null ? 0 : 1)) / 2)
    );
    let input = 0;
    let output = 0;
    if (this.pending !== null && chunk.byteLength) {
      samples[output++] = this.sample(this.pending, chunk[input++]);
      this.pending = null;
    }
    while (input + 1 < chunk.byteLength) {
      samples[output++] = this.sample(chunk[input], chunk[input + 1]);
      input += 2;
    }
    if (input < chunk.byteLength) this.pending = chunk[input];
    return samples;
  }

  finish(): void {
    if (this.closed) throw new Error('Audio stream has ended');
    this.closed = true;
    const truncated = this.pending !== null;
    this.pending = null;
    if (truncated) throw new Error('Audio stream ended within a sample');
  }

  cancel(): void {
    this.closed = true;
    this.pending = null;
  }

  private sample(low: number, high: number): number {
    const unsigned = low | (high << 8);
    return (unsigned >= 0x8000 ? unsigned - 0x10000 : unsigned) / 0x8000;
  }
}
